<template>
    <v-select
        :model-value="modelValue"
        :items="languageOptions"
        :label="label || $t('addEmployee.spokenLanguages')"
        multiple
        item-title="label"
        item-value="value"
        hide-details="auto"
        @update:modelValue="$emit('update:modelValue', $event)"
    />
</template>

<script>
export default {
    name: "SelectSpokenLanguages",
    props: {
        modelValue: Array,
        label: String,
    },
    emits: ["update:modelValue"],
    computed: {
        languageOptions() {
            return [
                { value: "ro", label: this.$t("language.ro") },
                { value: "en", label: this.$t("language.en") },
                { value: "de", label: this.$t("language.de") },
                { value: "fr", label: this.$t("language.fr") },
                { value: "hu", label: this.$t("language.hu") },
                { value: "bg", label: this.$t("language.bg") },
                { value: "pl", label: this.$t("language.pl") },
                { value: "sr", label: this.$t("language.sr") },
                { value: "hr", label: this.$t("language.hr") },
                { value: "sl", label: this.$t("language.sl") },
                { value: "sk", label: this.$t("language.sk") },
                { value: "it", label: this.$t("language.it") },
            ];
        },
    },
};
</script>
